import Message from 'components/Message';
import { RelatedProductsAccordion } from 'components/Product';
import { PRODUCT_DETAILS_BELONGS_TO_ID } from 'constants/ids';
import type { VariantId } from 'models/product';

import { useBelongsToContext } from '../ProductDetailsContext';

interface Props {
	belongsToListMessage: string;
	contentClassName: string;
	expiredProductsTitle: string;
	loadMoreButtonText: string;
	noProductsText: string;
	title: string;
	variantId: VariantId;
}

export default function BelongsToAccordion({
	belongsToListMessage,
	contentClassName,
	expiredProductsTitle,
	loadMoreButtonText,
	noProductsText,
	title,
	variantId,
}: Props) {
	const {
		hasNextPage,
		isLoading,
		isLoadingMore,
		isOpen,
		items,
		loadMore,
		toggleOpen,
	} = useBelongsToContext();
	return (
		<RelatedProductsAccordion
			title={title}
			accordionId={PRODUCT_DETAILS_BELONGS_TO_ID}
			expiredProductsTitle={expiredProductsTitle}
			loadMoreButtonText={loadMoreButtonText}
			gtmItemListId="pdp_belongs_to"
			gtmItemListName={`List: Belongs to ${variantId}`}
			noProductsText={noProductsText}
			afterListContent={
				<Message
					variant="information"
					text={belongsToListMessage}
					className="mt-4"
				/>
			}
			products={items}
			isLoadingInitial={isLoading}
			isLoadingMore={isLoadingMore}
			hasNextPage={hasNextPage}
			onLoadMoreClick={loadMore}
			contentClassName={contentClassName}
			isOpen={isOpen}
			onClick={toggleOpen}
		/>
	);
}

BelongsToAccordion.displayName = 'BelongsToAccordion';
